import React from 'react'
import StandardRuleTable from "./standard-rule-table";

export default function Index({ruleset, rules, handleUpdate, handleCreateRule, handleDeleteRule, handleUpdateRuleOrder}) {
  switch(ruleset.policy_type) {
    case 'discount':
    case 'rebate':
    case 'def_rebate':
      return <StandardRuleTable
        ruleset={ruleset}
        rules={rules}
        handleUpdateRuleOrder={handleUpdateRuleOrder}
        handleUpdate={handleUpdate}
        handleCreateRule={handleCreateRule}
        handleDeleteRule={handleDeleteRule}
      />
    default:
      return null;
  }
}
